export default [
  {
    name: 'Check-ins',
    path: 'admin/reports/checkins',
    filters: [
      { name: 'Filter by session', prop: 'filters.session_id', type: 'autocomplete', references: 'admin/sessions', referenceProp: 'name', displayProp: 'long_name', enabled: true }
    ]
  },
  { name: 'Goals', path: 'admin/reports/goals' },
  { name: 'Groups', path: 'admin/reports/groups' },
  { name: 'Order Report Advanced',
    path: 'admin/reports/order-advanced-products',
    filters: [
      { name: 'Filter by A/R Date', prop: 'filters.ar_date', type: 'datepicker', enabled: true }
    ]
  },
  { name: 'Order Products',
    path: 'admin/reports/order-products',
    filters: [
      { name: 'Filter by A/R Date', prop: 'filters.ar_date', type: 'datepicker', enabled: true }
    ] },
  { name: 'Order Summary',
    path: 'admin/reports/order-summary',
    filters: [
      { name: 'Filter by A/R Date', prop: 'filters.ar_date', type: 'datepicker', enabled: true }
    ] },
  { name: 'Session Registrations', path: 'admin/reports/session-registrations' },
  { name: 'Session Sales', path: 'admin/reports/session-sales' },
  { name: 'Sessions', path: 'admin/reports/sessions' },
  { name: 'Users', path: 'admin/reports/users' },
  { name: 'Webinar Registrations', path: 'admin/reports/webinar-registrations' },
  { name: 'Webinars', path: 'admin/reports/webinars' }
]
